module.exports = __webpack_public_path__ + "img/new_pass.72d3556f.svg";